import {Pipe, PipeTransform} from '@angular/core';

@Pipe ({
  name: 'inviteresponsemap'
})
export class InviteResponsePipe implements PipeTransform {
  transform(value: any, limit?: number) {
    if (value != null && value.toString().toUpperCase() === 'INVITATION_NOT_FOUND') {
      return 'We were unable to find your invitation, please try again later.';
    }
    if (value != null && value.toString().toUpperCase() === 'INVALID_INVITE_TOKEN') {
      return 'Your invitation token was invalid, please check.';
    }
    if (value != null && value.toString().toUpperCase() === 'INVALID_OPERATION') {
      return 'Your invitation action was invalid please check.';
    }
    if (value != null && value.toString().toUpperCase() === 'INVITATION_EXPIRED') {
      return 'We could not add you to the latestGame, your invitation has expired.';
    }
    if (value != null && value.toString().toUpperCase() === 'GAME_CANCELLED') {
      return 'We could not add you to the latestGame, the latestGame has been cancelled.';
    }
    return value;
  }
}
